import React, {Component} from 'react';
import {Home} from './components/home/Home';
import {Header} from './components/header/Header';
import Resume from './components/resume/Resume';
import {ErrorPage} from './components/common/ErrorPage';
import {Footer} from './components/footer/Footer';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import classNames from 'classnames';
import './App.css';
import withTracker from './components/common/withTracker/withTracker';
import ScrollButton from './components/common/ScrollButton/ScrollButton';

class App extends Component {

  state = {
    isBackgroundTransparent: true,
    showSplashImage: true,
    hideFullHeader: false,
    isMenuOpen: false,
    showScrollButton: false,
  };

  componentDidMount() {
    switch (window.location.pathname) {
      case '/':
        this.setState({isBackgroundTransparent: true, showSplashImage: true, });
        break;
      case '/resume':
        this.setState({isBackgroundTransparent: false, showSplashImage: false});
        break;
      default:
        this.setState({isBackgroundTransparent: true, showSplashImage: false});
    }
    const myDiv = document.getElementById('root');
    myDiv.scrollTop = 0;
    window.addEventListener('scroll', () => this.headerFx());

    // TODO: dynamic width and letter spacing calculation for menu working process
    /*
    let list = document.querySelectorAll('header ul li a');
    let widestMenuItems =[];
    for(let i =0; i < list.length; i++){
      widestMenuItems.push(list[i].offsetWidth)
    }
    let widestMenuItem = Math.max(...widestMenuItems);
    */
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => this.headerFx())
  }

  headerFx = () =>{
    if (window.scrollY > 150) {
      this.setState({hideFullHeader: true,showScrollButton: true})
    } else if (window.scrollY < 36) {
      this.setState({hideFullHeader: false,showScrollButton: false})
    }
  };

  updateMenuState = (x, y) => {
    this.setState({isBackgroundTransparent: x, showSplashImage: x});
    if (x === y) {
      this.setState({isMenuOpen: false})
    } else {
      this.toggleMenu();
    }
  };

  toggleMenu = () => {
    this.setState({isMenuOpen: !this.state.isMenuOpen,})
  };

  render() {
    const {isBackgroundTransparent, showSplashImage, hideFullHeader, isMenuOpen, showScrollButton} = this.state;
    return (
      <Router>
        <div id="initSplash" className={classNames({[`splash-image`]: showSplashImage})}>
          <Header
            isBackgroundTransparent={isBackgroundTransparent}
            updateMenuState={this.updateMenuState}
            hideFullHeader={hideFullHeader}
            toggleMenu={this.toggleMenu}
            isMenuOpen={isMenuOpen}
          />
          <Switch>
            <Route exact path="/" component={withTracker(Home)}/>
            <Route path="/resume" component={withTracker(Resume)}/>
            <Route component={ErrorPage}/>
          </Switch>
          <Footer isBackgroundTransparent={isBackgroundTransparent}/>
          <ScrollButton scrollStepInPx="50" delayInMs="16.66" showScrollButton={showScrollButton}/>
        </div>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js